import React, { useEffect, useMemo, useState } from "react"
import { getApiCallState, IBookingTariffSegment, ICarriageLayout, ICarriageLayouts, ISeat, useStateSelector } from "../Models"
import { Alert, Button, Nav } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { closeSeatmap, getCarriageLayout, updateSeats } from "../Actions";
import { SpinnerSmall } from "../../Shared/Components/Spinner";
import { clearApiCallState } from "../ApiCalls/Actions";
import { getErrorAsStrings } from "../Shared/Utils";
import { Carriage } from "./Carriage";
import { BookingFooter } from "../Components/BookingFooter";

export const ChangeSeats = () => {

	const dispatch = useDispatch();

	const bookingNumber = useStateSelector(state => state.passengersAndPayment.booking?.bookingNumber);
	const state = useStateSelector(state => state.passengersAndPayment.seatChange);
	const segment = state?.tariffSegment;
	const carriageLayout = state?.carriageLayout;

	const apicalls = getApiCallState();
	const getLayoutState = apicalls.getLoadingState("getCarriageLayout");
	const updateState = apicalls.getLoadingState("updateSeats");

	const selectedSeats = useMemo(() => {
		const groupedByCarriage = state.selectedSeats.reduce((arr, seat) =>{
			let carriage = arr.find(x => x.carriage === seat.seat.carriage);
			if (!carriage) {
				carriage = { carriage: seat.seat.carriage, seats: [] };
				arr.push(carriage);
			}
			carriage.seats.push(seat.seat.number);
			return arr;
		} ,[] as {carriage: string, seats: string[]}[]);
		//Sortera platserna i nummerordning
		groupedByCarriage.forEach(x => x.seats.sort());
		return groupedByCarriage;
	}, [state.selectedSeats]);

	const updateError = useMemo(() => {
		if (updateState !== "error")
			return "";

		const error = apicalls.getError("updateSeats");
		if (!error)
			return "";

		const errors = getErrorAsStrings(error);
		return errors.join(" ");
	}, [updateState]);

	useEffect(() => {
		if (segment && getLayoutState !== "loading")
			dispatch(getCarriageLayout(segment.validityService, segment.departureStation.uicStationCode, segment.arrivalStation.uicStationCode, segment.travelDate));
	}, [segment?.id]);

	useEffect(() => {
		if (updateState === "loaded")
			close();
	}, [updateState]);

	const submit = () => {
		//TODO: Gör ingenting om vi har exakt samma platser som tidigare

		dispatch(updateSeats(bookingNumber, state.selectedSeats.map(x => ({ itemId: x.itemId, carriage: x.seat.carriage, number: x.seat.number}))));
	};

	const close = () => {
		dispatch(clearApiCallState("updateSeats"));
		dispatch(closeSeatmap());
	}

	if (!segment)
		return null;

	return <div className="body">
		<section>
			<h2>Ändra platser</h2>

			<h3 className="mb-4">{segment?.departureStation.name} - {segment?.arrivalStation.name}</h3>

			<Alert variant="info" show={getLayoutState === "loading"}>Hämtar vagnslayout... <SpinnerSmall /></Alert>
			<Alert variant="danger" show={getLayoutState === "error"}>Get gick inte att hämta vagnslayout!</Alert>

			{ carriageLayout && <>

				<Seatmap carriageLayouts={carriageLayout} segment={segment} selectedSeats={state.selectedSeats} />

				<h4>Valda platser</h4>
				<ul className="list-unstyled">
					{selectedSeats.map(x => <li key={x.carriage}>Vagn {x.carriage}, plats {x.seats.sort().join(", ")}</li>)}
				</ul>
			</>}

			<Alert variant="danger" show={updateState === "error"}>Det gick inte att spara de valda platserna. {updateError}</Alert>

			<BookingFooter backText={"Avbryt"} onBack={close} submitButton={<Button variant="primary" onClick={submit} disabled={updateState === "loading"}>Spara {updateState === "loading" && <SpinnerSmall />}</Button>} />
		</section>
	</div>
}

const Seatmap = (props: { carriageLayouts: ICarriageLayouts, segment: IBookingTariffSegment, selectedSeats: { itemId: string, seat: ISeat }[]}) => {

	const [carriage, setCarriage] = useState<ICarriageLayout>();

	const carriages = props.carriageLayouts.carriages.filter(x => x.template && x.seats.some(y => y.available && y.inventoryClass === props.segment.requiredProducts[0].inventoryClass));

	useEffect(() => {
		//Den vagn som den första passageraren sitter i
		const c = props.carriageLayouts?.carriages.find(x => x.carriageNumber === props.segment?.requiredProducts[0].seat?.carriage);
		if (c)
			setCarriage(c);
		else if (props.carriageLayouts?.carriages?.length > 0)
			setCarriage(props.carriageLayouts.carriages[0]);
	}, [props.carriageLayouts, props.segment]);

	const changeCarriage = (newCarriage: ICarriageLayout) => {
		setCarriage(newCarriage);
	};

	if (carriages.length == 0)
		return <Alert variant="warning">Det finns inga vagnar att visa!</Alert>

	return <div className="mb-3">
		<Nav variant="pills" defaultActiveKey={carriage?.carriageNumber} className="mb-2">
			{ carriages.map(c => <Nav.Item key={c.carriageNumber}><Nav.Link active={c.carriageNumber === carriage?.carriageNumber} onClick={() => changeCarriage(c)}>Vagn {c.carriageNumber}</Nav.Link></Nav.Item>)}
		</Nav>
		<div className="seatmap">
			<Carriage carriage={carriage} segment={props.segment} selectedSeats={props.selectedSeats}/>
		</div>
	</div>;
}